"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var markItemsAsPinnedService_1 = require("../services/markItemsAsPinnedService");
var markItemsAsPinnedStoreUpdate_1 = require("owa-mail-actions/lib/triage/markItemsAsPinnedStoreUpdate");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var undoActions = require("owa-mail-undo");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Pin or unpin items
 * @param rowKeys the row keys
 * @param tableView that the pinned/unpinned items are in
 * @param shouldMarkAsPinned the pin value to be set
 * @param actionSource the action source
 */
exports.default = legacy_1.action('pinItems', datapoints_1.default.pinItemsDatapoint)(function pinItems(rowKeys, tableView, shouldMarkAsPinned, actionSource) {
    undoActions.clearLastUndoableAction();
    // Get all the row keys to update by checking if the existing pinned value is the same as the one to set
    var filteredRowKeys = filterRowKeysByPinValue(rowKeys, tableView, shouldMarkAsPinned);
    // Get the dedupped item ids to update, as multiple rowKeys could map to the same rowId
    var itemIdStringsToUpdate = owa_mail_list_store_1.getRowIdsFromRowKeys(filteredRowKeys, tableView.id);
    if (itemIdStringsToUpdate.length == 0) {
        // No need to send out the service call
        return Promise.resolve();
    }
    markItemsAsPinnedStoreUpdate_1.default(filteredRowKeys, tableView.id, shouldMarkAsPinned);
    // Make service request
    // Task 658: Reload client state when pin action fails on the server
    markItemsAsPinnedService_1.default(itemIdStringsToUpdate, shouldMarkAsPinned);
    // return the promise to catch the end to end time of pinItemsDatapoint
    return Promise.resolve();
});
/**
 * Filter the row keys to update by the pin value
 * @param rowKeys to pin/unpin
 * @param tableView that the rows belong to
 * @param shouldMarkAsPinned isPinned value to be set
 */
function filterRowKeysByPinValue(rowKeys, tableView, shouldMarkAsPinned) {
    var filteredRowKeys = [];
    rowKeys.forEach(function (rowKey) {
        if ((owa_mail_list_store_1.MailRowDataPropertyGetter.getIsPinned(rowKey, tableView) && !shouldMarkAsPinned) ||
            (!owa_mail_list_store_1.MailRowDataPropertyGetter.getIsPinned(rowKey, tableView) && shouldMarkAsPinned)) {
            filteredRowKeys.push(rowKey);
        }
    });
    return filteredRowKeys;
}
//# sourceMappingURL=pinItems.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/pinItems.js
// module id = 3823
// module chunks = 62